import React from "react";
import {
  TotalSalesChart,
  TotalTopUpsChart,
  TotalReturnCreditsChart,
  CheckInsChart,
  TopProductsChart,
  TopSpendingGuestsChart,
  // LowOrOutOfStockChart,
  TopCategoriesBySalesChart,
  TotalSalesOfLocationChart,
  SalesOverTimeChart,
  LocationsSalesCard,
} from "./chart";
import ChartContainer from "./chart-container";
import lang from "translations";
import classnames from "classnames";
import { Tooltip } from "components";
import { Text } from "components/commons";
import { formatNumberWithComma } from "services";
import { formatNumberToMoneyCurrency, getCurrencySymbol } from "services/money.service";
import moment from "moment";
import styles from "./dashboard-charts.module.scss";

const DashboardCharts = ({
  graphOfTotalSales,
  graphOfTotalSalesOfLocation,
  topLocationsBySales,
  graphOfTopUpSales,
  graphOfReturnCredits,
  graphOfActivatedGuest,
  topProductsBySales,
  topSpendingGuest,
  outOfStockProducts,
  topCategoriesBySales,
  averageOrderValue,
  totalTransactionsValue,
  totalUnspentCredits,
  totalCreditsReceived,
  totalCreditsKept,
  hasLocations,
  selectedLocationOptions,
}) => {
  const renderMoneyKpiAmount = (value, suffix) => (
    <div className={classnames("mt-sm", styles.kpiAmount)}>
      <span className={styles.kpiCurrency}>{getCurrencySymbol()}</span>
      <span className={styles.kpiNumber}>{formatNumberToMoneyCurrency(value || 0)}</span>
      {suffix && <span className={styles.kpiAmountSuffix}>{suffix}</span>}
    </div>
  );

  const renderNumberKpiAmount = (value) => (
    <div className={classnames("mt-sm", styles.kpiAmount)}>
      <span className={styles.kpiNumber}>{formatNumberWithComma(value || 0)}</span>
    </div>
  );

  const totalSalesValue = hasLocations
    ? graphOfTotalSalesOfLocation.mappedData?.totalSale
    : graphOfTotalSales.mappedData?.totalSales;
  const totalSalesSubtitle = (() => {
    const [startDate, endDate] = graphOfTotalSales.submittedParams?.dateRange || [];
    const dateText =
      startDate && endDate
        ? `${moment(startDate).format("MMM D")} - ${moment(endDate).format("MMM D, YYYY")}`
        : "";
    const locationCount = graphOfTotalSales.submittedParams?.locationIds?.length || 0;
    const locationText =
      locationCount === 1
        ? selectedLocationOptions?.[0]?.text || `${locationCount} location`
        : locationCount
          ? `${locationCount} locations`
          : lang.allLocations;
    const formattedLocationText = locationCount === 1 ? locationText : locationText.toLowerCase();

    return [dateText, formattedLocationText].filter(Boolean).join(" - ");
  })();

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className={styles.dashboardTopRow}>
        <div className={classnames("col-span-12", styles.totalSalesHeroCard)}>
          <div className={styles.totalSalesHeroLabel}>{lang.totalSales}</div>
          <div className={styles.totalSalesHeroAmount}>
            <span className={styles.totalSalesHeroCurrency}>{getCurrencySymbol()}</span>
            {formatNumberToMoneyCurrency(totalSalesValue || 0)}
          </div>
          <div className={styles.totalSalesHeroSubtitle}>{totalSalesSubtitle}</div>
        </div>

        {/*
      {hasLocations ? (
        <div className={classnames("md:col-span-12 col-span-12")}>
          <TotalSalesOfLocationChart {...graphOfTotalSalesOfLocation} />
        </div>
      ) : (
        <div className={classnames("col-span-12")}>
          <TotalSalesChart {...graphOfTotalSales} />
        </div>
      )}
      */}

        <div className={classnames("md:col-span-4 col-span-12", styles.topUpsCard)}>
          <TotalTopUpsChart {...graphOfTopUpSales} />
        </div>
        <div className={classnames("md:col-span-4 col-span-12", styles.returnCreditsCard)}>
          <TotalReturnCreditsChart {...graphOfReturnCredits} />
        </div>
        <div className={classnames("md:col-span-4 col-span-12", styles.checkInsCard)}>
          <CheckInsChart {...graphOfActivatedGuest} />
        </div>
      </div>
      {/* <div className="md:col-span-4 col-span-12">
        <ChartContainer
          title={lang.totalUnspentCredits}
          {...totalUnspentCredits}
          h="auto"
          className={styles.averageOrderValueCard}
        >
          <Text className="text-sm text-gray">
            <lang.Translate
              text={lang.totalUnspentCreditsDesc}
              items={[
                <Tooltip
                  title={lang.propertyManagementSystemExample}
                  placement="topRight"
                  className="text-sm underline cursor-pointer"
                >
                  {lang.propertyManagementSystem}
                </Tooltip>,
              ]}
            />
          </Text>
          {renderMoneyKpiAmount(
            totalUnspentCredits.result?.data,
            <Tooltip
              className={classnames("cursor-pointer", styles.kpiTooltip)}
              title={lang.valueCanStillChangeTooltip}
            >
              <span className="icon-warning text-gray-400 text-xs ml-xs"></span>
            </Tooltip>
          )}
        </ChartContainer>
      </div> */}
      <div className={classnames("md:col-span-4 lg:col-span-3 col-span-12", styles.kpiMetricCardWrap)}>
        <ChartContainer
          title={lang.totalTransactions}
          {...totalTransactionsValue}
          h="auto"
          className={styles.averageOrderValueCard}
        >
          {renderNumberKpiAmount(totalTransactionsValue.result?.data)}
        </ChartContainer>
        {/* <ChartContainer
          title={lang.dashboardCreditsKept}
          {...totalCreditsKept}
          tooltipText={lang.totalCreditsKeptTooltip}
          h="auto"
          className={classnames("mt-2", styles.averageOrderValueCard)}
        >
          {renderMoneyKpiAmount(totalCreditsKept.result?.data)}
        </ChartContainer> */}
      </div>
      <div className={classnames("md:col-span-4 lg:col-span-3 col-span-12", styles.kpiMetricCardWrap)}>
        <ChartContainer
          title={lang.averageOrderValue}
          {...averageOrderValue}
          h="auto"
          className={styles.averageOrderValueCard}
        >
          {renderMoneyKpiAmount(averageOrderValue.result?.data)}
        </ChartContainer>
      </div>
      <div className={classnames("md:col-span-4 lg:col-span-3 col-span-12", styles.kpiMetricCardWrap)}>
        <ChartContainer
          title={lang.dashboardCreditsReceived}
          {...totalCreditsReceived}
          tooltipText={lang.totalCreditsReceivedTooltip}
          h="auto"
          className={classnames(styles.averageOrderValueCard)}
        >
          {renderMoneyKpiAmount(totalCreditsReceived.result?.data)}
        </ChartContainer>
      </div>
      <div className={classnames("md:col-span-4 lg:col-span-3 col-span-12", styles.kpiMetricCardWrap)}>
        <ChartContainer
          title={lang.totalUnspentCredits}
          {...totalUnspentCredits}
          h="auto"
          className={styles.averageOrderValueCard}
        >
          {/* <Text className="text-sm text-gray">
            <lang.Translate
              text={lang.totalUnspentCreditsDesc}
              items={[
                <Tooltip
                  title={lang.propertyManagementSystemExample}
                  placement="topRight"
                  className="text-sm underline cursor-pointer"
                >
                  {lang.propertyManagementSystem}
                </Tooltip>,
              ]}
            />
          </Text> */}
          {renderMoneyKpiAmount(
            totalUnspentCredits.result?.data,
            <Tooltip
              className={classnames("cursor-pointer", styles.kpiTooltip)}
              title={lang.valueCanStillChangeTooltip}
            >
              <span className="icon-warning text-gray-400 text-xs ml-xs"></span>
            </Tooltip>,
          )}
        </ChartContainer>
      </div>

      <div className="col-span-12">
        <div className={styles.salesInsightsGrid}>
          <SalesOverTimeChart {...graphOfTotalSales} />
          <LocationsSalesCard {...topLocationsBySales} />
        </div>
      </div>
      <div className="md:col-span-6 xl:col-span-4 col-span-12">
        <TopSpendingGuestsChart {...topSpendingGuest} />
      </div>
      {/* <div className="md:col-span-6 col-span-12">
        <LowOrOutOfStockChart {...outOfStockProducts} />
      </div> */}
      <div className="md:col-span-6 xl:col-span-4 col-span-12">
        <TopCategoriesBySalesChart {...topCategoriesBySales} />
      </div>

      <div className="md:col-span-6 xl:col-span-4 col-span-12">
        <TopProductsChart {...topProductsBySales} />
      </div>
    </div>
  );
};

export default DashboardCharts;
